import { VoiceAction } from '@community_dev/types/lib/api/InfobipVoice'

export const VOICE_ACTION_LABELS: Record<VoiceAction, string> = {
  EXTERNAL: 'External',
  FORWARD_TO_CALL_ROUTING: 'Forward to Call Routing',
  FORWARD_TO_IVR: 'Forward to IVR',
  FORWARD_TO_PSTN: 'Forward to PSTN',
  FORWARD_TO_SUBSCRIPTION: 'Forward to Subscription',
  VOICE_FORWARD_TO_ANSWERS: 'Voice Forward to Answers',
  VOICE_FORWARD_TO_CONVERSATIONS: 'Voice Forward to Conversations',
  VOICE_NUMBER_MASKING: 'Voice Number Masking',
}

export const VOICE_ACTION_PAYLOAD_PLACEHOLDERS: Record<VoiceAction, string> = {
  EXTERNAL: 'e.g., Managed by Pro Services',
  FORWARD_TO_CALL_ROUTING: 'Call Routing Route ID',
  FORWARD_TO_IVR: 'IVR Scenario Key',
  FORWARD_TO_PSTN: 'PSTN number',
  FORWARD_TO_SUBSCRIPTION: 'Calls Configuration ID',
  VOICE_FORWARD_TO_ANSWERS: 'Description payload',
  VOICE_FORWARD_TO_CONVERSATIONS: 'Description payload',
  VOICE_NUMBER_MASKING: 'Voice Number Masking Config Key',
}
